import { paletteV3 } from "@tokenterminal/ui/tokens"
import clsx from "clsx"
import { type ElementType } from "react"
import { type SVGProps } from "types/Types"
import { dashboardIcon } from "./DashboardIcon.css"

interface IconProps {
  name?: string
  size?: SVGProps["width"]
  icon: null | ElementType
}

type DashboardIconProps = SVGProps & IconProps

// Icon styles for Market sector and Metric icons at least. Basically for any "entity" we display as dashboard and render as SVG
export const DashboardIcon = ({
  name,
  size = "40",
  className,
  icon: Icon,
  ...svgProps
}: DashboardIconProps) => {
  return (
    Icon && (
      <Icon
        color={paletteV3.muted}
        width={size}
        role={name ? "image" : "presentation"}
        aria-label={name ? `${name} -icon` : undefined}
        className={clsx(dashboardIcon, className)}
        {...svgProps}
      />
    )
  )
}
